import EntryForm from '../../pages/entry/EntryForm'
import ForgotPassword from '../../pages/entry/ForgotPassword'

const entryRoutes = [
    {
        path: "/login",
        element: EntryForm,
        props:{title:'Login to your application', purpose:'login', cta:'Login'},
    },
    {
        path: "/register",
        element: EntryForm,
        props:{title:'Register your account', purpose:'register', cta:'Sign Up'},
    },
    {
        path: "/forgotPassword",
        element: ForgotPassword,
        props: {},
    },
];

export default entryRoutes;